/**
 * Stable, crawlable metadata for the public TravelAIBG sections.
 * Private dashboards, account pages and arbitrary deep links are not indexed.
 * No page asserts confirmed reservations, guaranteed lowest prices or live stock.
 */
const PAGES = {
  home: {
    path: '/',
    en: ['TravelAIBG — AI Travel Planner for Flights, Hotels & Trips',
      'Plan flights, hotel searches and multi-city itineraries with an AI travel assistant. Confirm live availability, final prices and bookings directly with travel partners.'],
    bg: ['TravelAIBG — AI планер за пътувания, полети и хотели',
      'Планирайте полети, хотели и пътувания с няколко дестинации с AI асистент. Проверявайте наличностите, цените и условията за резервация при партньорите.'],
  },
  flights: {
    path: '/flights',
    en: ['Flight Search — Compare Partner Offers | TravelAIBG',
      'Search flight routes and dates with TravelAIBG. Confirm the current fare, luggage, availability and payment terms with the airline or booking partner.'],
    bg: ['Самолетни билети и полети | TravelAIBG',
      'Търсете маршрути и дати за полети. Проверете крайната цена, багажа и свободните места при партньора, преди да резервирате.'],
  },
  hotels: {
    path: '/hotels',
    en: ['Hotel Search — Compare Accommodation Options | TravelAIBG',
      'Find a destination and stay dates. Explore hotel partner searches and confirm room availability, final price, taxes and cancellation terms before booking.'],
    bg: ['Търсене на хотели и места за настаняване | TravelAIBG',
      'Изберете дестинация и дати за настаняване. Проверете свободните стаи, крайните цени, таксите и условията за анулация при доставчика.'],
  },
  packages: {
    path: '/packages',
    en: ['Multi-City Itineraries & Travel Plans | TravelAIBG',
      'Explore itineraries with several cities and separate flight and hotel partner searches. Each leg is booked independently with the provider.'],
    bg: ['Маршрути с няколко дестинации | TravelAIBG',
      'Открийте маршрути с няколко града, полети и хотелски търсения. Всяка отсечка се резервира отделно при съответния доставчик.'],
  },
  faq: { path: '/faq', en: ['Frequently Asked Questions | TravelAIBG', 'Answers about planning trips, partner bookings and TravelAIBG.'], bg: ['Често задавани въпроси | TravelAIBG', 'Отговори за планирането на пътувания и партньорските резервации в TravelAIBG.'] },
  help: { path: '/help', en: ['Help & Support | TravelAIBG', 'Find guidance for TravelAIBG trip planning and partner booking links.'], bg: ['Помощ и поддръжка | TravelAIBG', 'Информация за планиране на пътувания и връзки към партньори.'] },
  contact: { path: '/contact', en: ['Contact TravelAIBG', 'Contact TravelAIBG about our travel planning website.'], bg: ['Контакти | TravelAIBG', 'Свържете се с TravelAIBG за въпроси относно сайта за планиране на пътувания.'] },
  privacy: { path: '/privacy', en: ['Privacy Policy | TravelAIBG', 'Read the TravelAIBG privacy policy.'], bg: ['Политика за поверителност | TravelAIBG', 'Прочетете политиката за поверителност на TravelAIBG.'] },
  terms: { path: '/terms', en: ['Terms of Service | TravelAIBG', 'Read the terms for using TravelAIBG.'], bg: ['Общи условия | TravelAIBG', 'Прочетете общите условия за използване на TravelAIBG.'] },
};

export function getPageMetadata(section = 'home', language = 'en') {
  const config = Object.prototype.hasOwnProperty.call(PAGES, section) ? PAGES[section] : null;
  const [title, description] = (config || PAGES.home)[language === 'bg' ? 'bg' : 'en'];
  return {
    title, description,
    canonicalPath: config ? config.path : '/',
    indexable: Boolean(config),
  };
}

export const publicSitemapRoutes = Object.values(PAGES).map(page => page.path);

/** Only canonical production hosts may ever be indexed. */
export function shouldIndexHost(hostname) {
  const host = String(hostname || '').toLowerCase();
  return host === 'travelaibg.com' || host === 'www.travelaibg.com';
}
